

type ErrorTextProps = {
  id: string;
  children: string;
  showIcon?: boolean;
};

const ErrorText = ({ id, children, showIcon = true }: ErrorTextProps) => {
  return (
    <div
      role='alert'
      id={id}
      className='flex items-center px-1 pt-1 text-xs text-red-600'
    >
      {showIcon && (
        <img src='/warningsharp.svg' alt='warning' className='mr-1' />
      )}
      {children}
    </div>
  );
};

export default ErrorText;
